import { render, staticRenderFns } from "./CRUDPessoas.vue?vue&type=template&id=1bcaaffa&scoped=true&"
import script from "./CRUDPessoas.vue?vue&type=script&lang=js&"
export * from "./CRUDPessoas.vue?vue&type=script&lang=js&"
import style0 from "./CRUDPessoas.vue?vue&type=style&index=0&id=1bcaaffa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bcaaffa",
  null
  
)

export default component.exports